import {
  ReceivingMethod,
  PersonalDetails,
  BankDetailsReduxForm,
  RecipientAdded,
  RecipientAddress
} from '../pages';

export const addBeneRevampRoutes = {
  receiving_method: ReceivingMethod,
  personal_details: PersonalDetails,
  bank_details: BankDetailsReduxForm,
  recipient_address: RecipientAddress,
  recipient_added: RecipientAdded
};
